/**
 * Megamenu Script - Clean Version
 * Hover for desktop, click for mobile
 * CSS should be added separately in your theme
 */

(function() {
    'use strict';
    
    // Configuration
    const CONFIG = {
        mobileBreakpoint: 768,
        activeClass: 'active',
        menuItemSelector: '.menu-li',
        menuLinkSelector: '.menu-link',
        megamenuSelector: '.megamenu',
        animationDelay: 100
    };
    
    // State
    let isMobile = window.innerWidth <= CONFIG.mobileBreakpoint;
    let activeMegamenu = null;
    let hoverTimeout = null;
    
    /**
     * Initialize megamenu system
     */
    function init() {
        // Get all menu items
        const menuItems = document.querySelectorAll(CONFIG.menuItemSelector);
        
        if (!menuItems.length) {
            console.log('No menu items found');
            return;
        }
        
        // Process each menu item
        menuItems.forEach(menuItem => {
            const menuLink = menuItem.querySelector(CONFIG.menuLinkSelector);
            const megamenu = menuItem.querySelector(CONFIG.megamenuSelector);
            
            // Skip if no megamenu
            if (!megamenu) return;
            
            // Add identifier class
            menuItem.classList.add('has-megamenu');
            
            // Setup events based on device
            if (isMobile) {
                setupMobileEvents(menuItem, menuLink, megamenu);
            } else {
                setupDesktopEvents(menuItem, menuLink, megamenu);
            }
        });
        
        // Setup global handlers
        setupGlobalHandlers();
    }
    
    /**
     * Setup desktop hover events
     */
    function setupDesktopEvents(menuItem, menuLink, megamenu) {
        // Clear any existing handlers by cloning
        const newMenuItem = menuItem.cloneNode(true);
        menuItem.parentNode.replaceChild(newMenuItem, menuItem);
        
        // Re-query elements
        const newMenuLink = newMenuItem.querySelector(CONFIG.menuLinkSelector);
        const newMegamenu = newMenuItem.querySelector(CONFIG.megamenuSelector);
        
        // Mouse enter menu item
        newMenuItem.addEventListener('mouseenter', function() {
            if (isMobile) return;
            clearTimeout(hoverTimeout);
            showMegamenu(newMenuItem, newMegamenu);
        });
        
        // Mouse leave menu item
        newMenuItem.addEventListener('mouseleave', function() {
            if (isMobile) return;
            hoverTimeout = setTimeout(() => {
                if (!newMegamenu.matches(':hover')) {
                    hideMegamenu();
                }
            }, CONFIG.animationDelay);
        });
        
        // Keep megamenu open when hovering over it
        newMegamenu.addEventListener('mouseenter', function() {
            if (isMobile) return;
            clearTimeout(hoverTimeout);
        });
        
        // Close when leaving megamenu
        newMegamenu.addEventListener('mouseleave', function() {
            if (isMobile) return;
            hoverTimeout = setTimeout(() => {
                if (!newMenuItem.matches(':hover')) {
                    hideMegamenu();
                }
            }, CONFIG.animationDelay);
        });
        
        // Prevent link default on desktop if has megamenu
        newMenuLink.addEventListener('click', function(e) {
            if (!isMobile && newMegamenu) {
                e.preventDefault();
            }
        });
    }
    
    /**
     * Setup mobile click events
     */
    function setupMobileEvents(menuItem, menuLink, megamenu) {
        // Clear any existing handlers
        const newMenuLink = menuLink.cloneNode(true);
        menuLink.parentNode.replaceChild(newMenuLink, menuLink);
        
        // Click handler for mobile
        newMenuLink.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Toggle megamenu
            if (activeMegamenu === megamenu) {
                hideMegamenu();
            } else {
                showMegamenu(menuItem, megamenu);
            }
        });
    }
    
    /**
     * Show megamenu
     */
    function showMegamenu(menuItem, megamenu) {
        // Hide any active megamenu first
        hideMegamenu();
        
        // Show new megamenu
        menuItem.classList.add(CONFIG.activeClass);
        megamenu.classList.add(CONFIG.activeClass);
        
        // Update state
        activeMegamenu = megamenu;
        
        // Prevent scroll on mobile
        if (isMobile) {
            document.body.style.overflow = 'hidden';
        }
    }
    
    /**
     * Hide megamenu
     */
    function hideMegamenu() {
        if (!activeMegamenu) return;
        
        // Clear timeout
        clearTimeout(hoverTimeout);
        
        // Find and remove active classes
        document.querySelectorAll(`.${CONFIG.activeClass}`).forEach(el => {
            el.classList.remove(CONFIG.activeClass);
        });
        
        // Restore scroll
        document.body.style.overflow = '';
        
        // Clear state
        activeMegamenu = null;
    }
    
    /**
     * Setup global handlers
     */
    function setupGlobalHandlers() {
        // ESC key to close
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && activeMegamenu) {
                hideMegamenu();
            }
        });
        
        // Click outside to close (mobile)
        document.addEventListener('click', function(e) {
            if (isMobile && activeMegamenu) {
                const isClickInside = e.target.closest(CONFIG.menuItemSelector) || 
                                     e.target.closest(CONFIG.megamenuSelector);
                if (!isClickInside) {
                    hideMegamenu();
                }
            }
        });
        
        // Window resize handler
        let resizeTimeout;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                const wasMobile = isMobile;
                isMobile = window.innerWidth <= CONFIG.mobileBreakpoint;
                
                if (wasMobile !== isMobile) {
                    hideMegamenu();
                    init(); // Reinitialize
                }
            }, 250);
        });
    }
    
    /**
     * Initialize when DOM ready
     */
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    // Shopify theme editor support
    if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', init);
        document.addEventListener('shopify:section:reorder', init);
    }
    
    // Export API
    window.megamenuAPI = {
        init: init,
        show: (menuItem) => {
            const megamenu = menuItem.querySelector(CONFIG.megamenuSelector);
            if (megamenu) showMegamenu(menuItem, megamenu);
        },
        hide: hideMegamenu,
        getActive: () => activeMegamenu
    };
})();